// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__JYaL5","title":"InfoRow_title__15J3k"};